module.exports = __webpack_public_path__ + "static/media/icn_kyc_incomplete.d365ab33.svg";